import { useTheme } from '@mui/material';
import { colors } from '@constants/colors';
import { useMytaverse } from '@providers/MytaverseProvider';
import { ScreenSizes } from '@interfaces';

export const useStyles = (primary: boolean, white: boolean) => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  return {
    root: {
      fontSize: 20,
      padding: '13px 32px',
      borderRadius: '99px',
      minWidth: '96px',
      fontWeight: 500,
      lineHeight: 1.4,
      textTransform: 'none',
      color: primary ? colors.white : white ? colors.white : colors.black,
      borderColor: primary
        ? appTheme.mainColor
        : white
        ? colors.white
        : colors.black,
      backgroundColor: primary ? appTheme.mainColor : 'transparent',
      '&:hover': {
        borderColor: primary
          ? appTheme.mainColor
          : white
          ? colors.white
          : colors.black,
        backgroundColor: primary ? appTheme.mainColor : 'transparent',
      },
      '&:disabled': {
        color: colors.white,
        backgroundColor: colors.grey_third,
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: '10px 18px',
        fontSize: 18,
      },
    },
  };
};
